/**
 * Jogador na barra de pesquisa — jaula com corrida e embaixadinhas (pés).
 */
(function () {
  if (typeof window === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var RUNNER_W = 72;
  var PAD = 6;
  var BALL_HALF = 7.5;
  var BALL_GAP = 5;
  var SVG_SCALE = 72 / 108;
  var FOOT_FRONT = Math.round(67 * SVG_SCALE - BALL_HALF + BALL_GAP);
  var FOOT_BACK = Math.round(39 * SVG_SCALE - BALL_HALF + 2);
  var JUGGLE_MAX_H = 10;
  var GRAVITY = 0.26;

  function initCage(cage) {
    var root = cage.querySelector('[data-copa-search-player]');
    if (!root || root.dataset.copaPlayerReady === '1') return;
    root.dataset.copaPlayerReady = '1';

    var runner = root.querySelector('.copa-header-player__runner');
    var ballWrap = root.querySelector('.copa-header-player__ball-wrap');
    if (!runner || !ballWrap) return;

    function bounds() {
      var w = cage.clientWidth;
      return {
        w: w,
        maxX: Math.max(PAD, w - RUNNER_W - PAD),
      };
    }

    function footBallX(useFront) {
      var front = FOOT_FRONT;
      var back = FOOT_BACK;
      if (facing === -1) {
        return useFront ? back : front;
      }
      return useFront ? front : back;
    }

    var b0 = bounds();
    var x = b0.maxX * 0.4;
    var vx = 0.45 + Math.random() * 0.22;
    var mode = 'run';
    var modeElapsed = 0;
    var modeDuration = 4200 + Math.random() * 3200;
    var facing = 1;
    var ballX = footBallX(true);
    var ballHeight = 0;
    var ballVelY = 0;
    var lastT = 0;
    var runPhase = 0;
    var touchLeg = 'front';
    var touchTimer = null;

    function setMode(next) {
      mode = next;
      root.classList.remove('is-touch-front', 'is-touch-back');
      root.classList.toggle('is-mode-run', mode === 'run');
      root.classList.toggle('is-mode-juggle', mode === 'juggle');
      modeElapsed = 0;
      modeDuration = mode === 'run' ? 3800 + Math.random() * 4000 : 3200 + Math.random() * 2800;

      if (mode === 'juggle') {
        vx = (Math.random() > 0.5 ? 1 : -1) * (0.1 + Math.random() * 0.08);
        ballHeight = 0;
        ballVelY = 2.3 + Math.random() * 0.9;
        touchLeg = 'front';
        ballX = footBallX(true);
      } else {
        vx = facing * (0.5 + Math.random() * 0.22);
        ballHeight = 0;
        ballVelY = 0;
        ballX = footBallX(true);
      }
    }

    function triggerFootTouch(kickingLeg) {
      root.classList.remove('is-touch-front', 'is-touch-back');
      root.classList.add(kickingLeg === 'front' ? 'is-touch-front' : 'is-touch-back');
      if (touchTimer) window.clearTimeout(touchTimer);
      touchTimer = window.setTimeout(function () {
        root.classList.remove('is-touch-front', 'is-touch-back');
      }, 100);
    }

    setMode(Math.random() > 0.4 ? 'run' : 'juggle');

    function clampPlayerX() {
      var b = bounds();
      if (x < PAD) {
        x = PAD;
        vx = Math.abs(vx);
        facing = 1;
      }
      if (x > b.maxX) {
        x = b.maxX;
        vx = -Math.abs(vx);
        facing = -1;
      }
    }

    function applyBallTransform() {
      ballWrap.style.transform =
        'translate3d(' + ballX + 'px,' + -ballHeight + 'px,0)';
      ballWrap.style.opacity = '1';
    }

    function tick(now) {
      if (!lastT) lastT = now;
      var dt = Math.min(32, now - lastT);
      lastT = now;
      var step = dt / 16.67;

      modeElapsed += dt;
      if (modeElapsed >= modeDuration) {
        setMode(mode === 'run' ? 'juggle' : 'run');
      }

      if (mode === 'run') {
        x += vx * step;
        runPhase += dt * 0.007;

        if (x <= PAD) {
          x = PAD;
          vx = Math.abs(vx);
          facing = 1;
          if (Math.random() < 0.12) setMode('juggle');
        } else if (x >= bounds().maxX) {
          x = bounds().maxX;
          vx = -Math.abs(vx);
          facing = -1;
          if (Math.random() < 0.12) setMode('juggle');
        }

        ballX = footBallX(true);
        ballHeight = Math.abs(Math.sin(runPhase * 2)) * 1.2;
        ballVelY = 0;
      } else {
        x += vx * step * 0.4;
        clampPlayerX();

        ballVelY -= GRAVITY * step;
        ballHeight += ballVelY * step;

        if (ballHeight <= 0) {
          var kicking = touchLeg;
          ballHeight = 0;
          ballVelY = 2.2 + Math.random() * 0.8;
          ballX = footBallX(kicking === 'front');
          triggerFootTouch(kicking);
          touchLeg = kicking === 'front' ? 'back' : 'front';
        } else if (ballHeight > JUGGLE_MAX_H) {
          ballHeight = JUGGLE_MAX_H;
          if (ballVelY > 0) ballVelY = 0;
        }
      }

      clampPlayerX();
      runner.style.transform = 'translate3d(' + x + 'px,0,0) scaleX(' + facing + ')';
      applyBallTransform();

      requestAnimationFrame(tick);
    }

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(clampPlayerX).observe(cage);
    }

    requestAnimationFrame(tick);
  }

  function boot() {
    document.querySelectorAll('.frm_search_input--with-player').forEach(initCage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
